import { module } from 'modujs';
import { Swiper, Scrollbar } from 'swiper';

export default class extends module {
    constructor(m) {
        super(m);

        this.carousel  = this.$('carousel')[0]
        this.scrollbar = this.$('scrollbar')[0]

        this.events = {
            click: {
                'dot': 'changeSlide',
                'close': 'closeCarousel'
            }
        }
    }

    init() {
        if (this.carousel && this.scrollbar) {
            this.carousel = new Swiper(this.carousel, {
                modules: [
                    Scrollbar,
                ],
                loop: false,
                slidesPerView: 1,
                spaceBetween: 10,
                simulateTouch: true,
                scrollbar: {
                    el: this.scrollbar,
                    draggable: true,
                },
                breakpoints: {
                    1000: {
                        simulateTouch: false,
                        spaceBetween: 0,
                        slidesPerView: 1
                    },
                }
            })
        }

        // Events
        // ==========================================================================
        this.closeBind = (e) => {
             if (e.key === 'Escape') {
                this.closeCarousel();
            }
        }

        document.addEventListener('keyup', this.closeBind)
    }

    /**
     * Change to slide of the main slider
     *
     * @param {event}
     * @return {void}
     */
    changeSlide(e) {
        let el = e.curTarget
        let index = Array.from(el.parentNode.children).indexOf(el)

        Array.from(el.parentNode.children).forEach((item) => {
            item.classList.remove('is-active')
        })

        this.openCarousel()

        el.classList.add('is-active')

        this.carousel.slideTo(index)
    }

    openCarousel() {
        if (!this.el.classList.contains('has-carousel-features-open')) {
            this.el.classList.add('has-carousel-features-open')
        }
    }

    closeCarousel() {
        this.$('dot').forEach((item) => {
            item.classList.remove('is-active')
        })

        this.el.classList.remove('has-carousel-features-open')
    }

    destroy() {
        this.carousel.destroy(true, true)
        document.removeEventListener('keyup', this.closeBind)
    }
}
